import ActivityFeed from '@app/components/ActivityFeed'
import FeedItemEditor from '@app/components/FeedItemEditor'
import { FeedItemSourceType } from '@app/models/enums'
import * as React from 'react'
import { ListingPageProps } from './ListingPage'

export default class ListingActivity extends React.PureComponent<
  ListingPageProps
> {
  public render() {
    return (
      <div key={this.props.listing.property.id}>
        <div className='mx-2'>
          <FeedItemEditor
            contextId={this.props.listing.property.id}
            contextType={FeedItemSourceType.Property}
          />
        </div>
        <ActivityFeed contextId={this.props.listing.property.id} />
      </div>
    )
  }
}
